// extracted by mini-css-extract-plugin
export default {"customOverlay":"styles_customOverlay__qs3+n","customModal":"styles_customModal__77k47","closeButton":"styles_closeButton__jQLC-"};